import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=3679f6eb&scoped=true&lang=pug&"
import script from "./CommentHistory.vue?vue&type=script&lang=coffee&"
export * from "./CommentHistory.vue?vue&type=script&lang=coffee&"
import style0 from "./CommentHistory.vue?vue&type=style&index=0&id=3679f6eb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679f6eb",
  null
  
)

export default component.exports